import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { footerPalette } from '../palette'

const COPYRIGHT_YEAR = 2026

export function LandingFooter() {
  const { t } = useTranslation()

  return (
    <footer style={{ background: footerPalette.bg, color: footerPalette.fg }}>
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '36px 24px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 20,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div
            style={{
              width: 22,
              height: 22,
              borderRadius: 6,
              background: footerPalette.brandMark,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: footerPalette.brandMarkFg,
              fontWeight: 800,
              fontSize: 11,
            }}
            aria-hidden="true"
          >
            {t('landing.brand.mark')}
          </div>
          <span style={{ fontSize: 13, color: footerPalette.muted }}>
            {t('landing.footer.copyright', { year: COPYRIGHT_YEAR, productName: t('productName') })}
          </span>
        </div>
        <nav style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
          <a href="#produto" style={{ fontSize: 13, color: footerPalette.fg }}>
            {t('landing.nav.produto')}
          </a>
          <a href="#planos" style={{ fontSize: 13, color: footerPalette.fg }}>
            {t('landing.nav.planos')}
          </a>
          <a href="#controle" style={{ fontSize: 13, color: footerPalette.fg }}>
            {t('landing.footer.security')}
          </a>
          <Link to="/signup" style={{ fontSize: 13, color: footerPalette.fg }}>
            {t('landing.footer.allScreens')}
          </Link>
        </nav>
      </div>
    </footer>
  )
}
